<template>
    <div class="navBottom flex flex-j-c flex-a-c font-18">
        <div class="content flex flex-col">
            <div class="flex flex-a-c top">
                <div>
                    <img src="../assets/img/logo.png" height="47" width="200" alt="">
                    <div class="mt-8">
                        <span @click="$router.push('/pc/about-us')">关于我们</span>
                        <span class="ml-6" @click="$router.push('/pc/product-center')">产品中心</span>
                        <span class="ml-6" @click="$router.push('/pc/customized-services')">定制服务</span>
                        <span class="ml-6" @click="$router.push('/pc/information-center/product-catalog')">资料中心</span>
                    </div>
                </div>
                <div class="code flex flex-col flex-a-c">
                    <img src="../assets/img/qrcode.jpg" alt="" style="width: 124px;height: 124px;">
                    <div class="mt-2">扫一扫关注公众号</div>
                </div>
                <div>
                    <div>客服电话</div>
                    <div class="font-24 mt-2">0755-26886631</div>
                    <div class="mt-3">邮箱：hpbiotech@huapua.com</div>
                    <div class="mt-2">公司地址：深圳市南山区招商街道赤湾社区赤湾五路六号赤湾石油大厦</div>
                </div>
            </div>
            <div class="flex flex-j-c flex-a-c bottom">
                <div>深圳华普生物医疗有限公司</div>
                <div style="margin-left: 50px;">粤ICP备2020086656号-1</div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'navBottom',
        data() {
            return {
            }
        },
        mounted() {
        },
        methods: {
        },

    }
</script>
<style scoped lang="scss">
    .navBottom {
        width: 100%;
        height: 360px;
        background: #F7F9FA;
        border-radius: 8px;
        .content {
            .top {
                height: 246px;
                position: relative;

                .code {
                    width: 470px;
                }
            }

            .top::after {
                content: '';
                left: 0;
                bottom: 0;
                position: absolute;
                width: 100%;
                height: 1px;
                background-color: #C3C8CA;
            }

            .bottom {
                height: 113px;
            }
        }
    }
</style>
